export const transformJsonToForm = (json: Record<string, unknown>) => {
  const form = new FormData()

  for (const [key, value] of Object.entries(json)) {
    if (value === undefined || value === null) {
      continue
    }

    if (Array.isArray(value)) {
      processArrayField(form, key, value)
    } else {
      processPrimitiveField(form, key, value)
    }
  }

  return form
}

const processArrayField = (
  form: FormData,
  key: string,
  arr: unknown[]
): void => {
  const isFilesKey = key === 'files'

  for (const item of arr) {
    if (item === undefined || item === null) {
      continue
    }

    if (isFilesKey || typeof item === 'string') {
      form.append(key, item as Blob)
    } else {
      form.append(key, JSON.stringify(item))
    }
  }
}

const processPrimitiveField = (
  form: FormData,
  key: string,
  value: unknown
): void => {
  if (key === 'file') {
    form.append(key, value as File)
  } else if (typeof value === 'object') {
    form.append(key, JSON.stringify(value))
  } else {
    const stringValue = String(value as number | string | boolean)

    form.append(key, stringValue)
  }
}

export const migrateFromV1ToV2 = (endpoint: string) =>
  endpoint.replace('/v1/', '/v2/')

export const migrateFromV1ToV3 = (endpoint: string) =>
  endpoint.replace('/v1/', '/v3/')

export const migrateFromV1ToV4 = (endpoint: string) =>
  endpoint.replace('/v1/', '/v4/')
